export default {
  startup: [],
  startupbyid: {},
  category_details: [],
  investment_status: {},
};
